var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3 1.5C4.99241 1.5 1.5 5.01349 1.5 9.34709C1.5 13.2632 4.35197 16.5091 8.08152 17.1V11.6159H6.10012V9.34709H8.08152V7.6182C8.08152 5.64996 9.24618 4.56459 11.0271 4.56459C11.8805 4.56459 12.7745 4.71763 12.7745 4.71763V6.64742H11.7884C10.8212 6.64742 10.5185 7.25328 10.5185 7.87404V9.34552H12.6801L12.3345 11.6143H10.5185V17.0984C14.248 16.5106 17.1 13.264 17.1 9.34709C17.1 5.01349 13.6076 1.5 9.3 1.5Z",
    fill: "#D6E0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.c5c726be8139140fc72435f5c41aaee3.svg";
export { ForwardRef as ReactComponent };